module.exports = __webpack_public_path__ + "img/arrow-right.0ed54472.svg";